import { type ReactNode } from 'react'
import styles from './InfoSectionItems.module.css'

export interface InfoSectionItemsProps {
  children: ReactNode
}

export function InfoSectionItems({ children }: InfoSectionItemsProps) {
  return <div className={styles.root}>{children}</div>
}

export interface InfoSectionItemProps {
  label: string
  children: ReactNode
}

export function InfoSectionItem({ label, children }: InfoSectionItemProps) {
  return (
    <>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{children}</div>
    </>
  )
}
